import React, { useState } from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { FileDownloadOutlined, ArrowForward } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';

const CensusDownload = () => {
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);

  const handleDownload = () => {
    setDownloadLoading(true);
    // Simulate download process
    setTimeout(() => {
      setDownloadLoading(false);
    }, 2000);
  };

  return (
    <Box>
      <Grid
        container
        spacing={2}
        alignItems="flex-end"
      >
        <Grid item>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={startDate}
              onChange={(date) => setStartDate(date || new Date())}
              maxDate={new Date()}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'outlined',
                  size: 'small',
                  sx: { minWidth: 150 },
                  label: 'Start Date',
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item>
          <IconButton
            size="small"
            sx={{ color: 'text.secondary' }}
          >
            <ArrowForward />
          </IconButton>
        </Grid>

        <Grid item>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={endDate}
              onChange={(date) => setEndDate(date || new Date())}
              maxDate={new Date()}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'outlined',
                  size: 'small',
                  sx: { minWidth: 150 },
                  label: 'End Date',
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item>
          <LoadingButton
            disabled={downloadLoading}
            startIcon={<FileDownloadOutlined />}
            variant="contained"
            size="small"
            sx={{
              whiteSpace: 'nowrap',
              height: 35,
              width: 120,
              ':hover': {
                background: '#6366F1',
              },
              '.MuiLoadingButton-loadingIndicator': {
                left: 15,
              },
            }}
            loadingPosition="start"
            onClick={handleDownload}
            loading={downloadLoading}
          >
            Download
          </LoadingButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CensusDownload;
